import { Component } from "@angular/core";
import { IHeaderAngularComp } from "ag-grid-angular";

@Component({
  selector: "app-custom-header",
  templateUrl: "./custom-header.component.html",
  styleUrls: ["./custom-header.component.scss"],
})
export class CustomHeaderComponent implements IHeaderAngularComp {
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  buttonClick(): void {
    if (this.params.onButtonClick) {
      this.params.onButtonClick(); // Chiama la funzione del componente principale
    }
  }

  refresh(params: any): boolean {
    return true;
  }
}
